import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Phuluctable from "components/Tonghopbaocao/Trungtamdangkiem/Phuluctable.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Phulucttdkchitiet = React.memo(function Phulucttdkchitiet(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [data, setData] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      console.log(thang);
      var url =
        Config.backend +
        "/api/BaoCao/bcpltrungtamdangkiem?username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setData(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  return (
    <GridContainer>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={8}>
        <GridContainer style={{ border: "0.1px solid #4f7edb" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <a className={classes.tieudecenter}>PHỤ LỤC</a>
              <a className={classes.tieudecenter}>
                DANH SÁCH ĐƠN VỊ ĐĂNG KIỂM XE CƠ GIỚI TRÊN ĐỊA BÀN TỈNH BÌNH
                ĐỊNH
              </a>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Phuluctable data={data} />
          </GridItem>
        </GridContainer>
      </GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
    </GridContainer>
  );
});

Phulucttdkchitiet.propTypes = {
  thangnam: PropTypes.object,
};
export default Phulucttdkchitiet;
